import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (window.Intl && typeof window.Intl === "object") {
      var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.element.value = timeZone;
    };
  }
}